import jwtDecode from 'jwt-decode';
import { BASE_PATH_SERVER } from './config';
import { ACCESS_TOKEN, REFRESH_TOKEN, PERFIL_ACTIVO_KEY } from '../utils/constants';

const willExpireToken = (token) => {
  const seconds = 60;
  const metaToken = jwtDecode(token);
  const { exp } = metaToken;
  const now = (Date.now() + seconds) / 1000;

  return now > exp;
};

/**
 * Guarda el par de tokens que entrega la API cuando la sesión cambia de versión, p. ej. al
 * cambiar la contraseña propia: el backend revoca todas las sesiones de la cuenta (incluida la
 * actual) y responde con tokens nuevos para que quien hizo el cambio no quede fuera.
 *
 * Solo escribe si vienen los DOS: un par a medias dejaría la sesión mezclada (un access nuevo
 * con un refresh viejo ya revocado) y habría que volver a ingresar al vencer el access.
 * Devuelve si guardó.
 */
export const guardarTokens = (respuesta) => {
  // `respuesta || {}` y no un valor por defecto: el default solo cubre `undefined`, y una
  // respuesta vacía llega como `null`/`''`. Lanzar acá haría fallar el formulario de cambio de
  // contraseña DESPUÉS de que la contraseña ya cambió.
  const { accessToken, refreshToken } = respuesta || {};
  if (typeof accessToken !== 'string' || typeof refreshToken !== 'string') return false;
  if (!accessToken || !refreshToken) return false;
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
  return true;
};

export const logout = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  // Evita que el próximo usuario que loguee en esta pestaña herede el
  // sombrero activo del usuario anterior (ver hooks/usePerfilActivo).
  sessionStorage.removeItem(PERFIL_ACTIVO_KEY);
};

export const getAccessTokenApi = () => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  if (!accessToken || accessToken === 'null' || accessToken === 'undefined') {
    return null;
  }
  return willExpireToken(accessToken) ? null : accessToken;
};
export const getRefreshTokenApi = () => {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  if (!refreshToken || refreshToken === 'null' || refreshToken === 'undefined') {
    return null;
  }
  return willExpireToken(refreshToken) ? null : refreshToken;
};
export const refreshAccessTokenApi = (refreshToken) => {
  const url = `${BASE_PATH_SERVER}refresh-access-token`;
  const bodyObj = {
    refreshToken,
  };
  const params = {
    method: 'POST',
    body: JSON.stringify(bodyObj),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(url, params)
    .then((response) => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then((result) => {
      if (result.error) {
        logout();
        return false;
      }
      localStorage.setItem(ACCESS_TOKEN, result.accessToken);
      localStorage.setItem(REFRESH_TOKEN, result.refreshToken);
      return true;
    });
};
